import type { Sport } from '../types/sport'

export function isSportEligible(
  sport: Sport,
  gender: 'Male' | 'Female',
  dob: Date
): boolean {
  // Gender validation
  if (sport.gender && sport.gender !== 'Mixed' && sport.gender !== gender) {
    return false
  }

  // Age validation using birthdates
  if (sport.min_birthdate) {
    const minDate = new Date(sport.min_birthdate)
    if (dob < minDate) return false // User too old
  }

  if (sport.max_birthdate) {
    const maxDate = new Date(sport.max_birthdate)
    if (dob > maxDate) return false // User too young
  }

  return true
}
